import Skeleton from '@mui/material/Skeleton';

import { BoxStyled } from './MerchantsEdit.styled';

export const MerchantsEditFormSkeleton: React.FC = () => {
  return (
    <BoxStyled sx={{ gap: '24px', marginBottom: '24px' }}>
      {Array.from({ length: 9 }).map((_, i) => (
        <Skeleton height={40} key={i} variant="rounded" width="100%" />
      ))}
    </BoxStyled>
  );
};
